export const findActiveSectionIndex = (
  sectionRects = [],
  viewportTop = 0,
  viewportHeight = 0,
  scrollTop = 0,
  scrollHeight = 0
) => {
  if (!sectionRects || sectionRects.length === 0) return 0;
  if (scrollTop <= 8) return 0;
  if (scrollHeight > viewportHeight && scrollTop + viewportHeight >= scrollHeight - 8) {
    return sectionRects.length - 1;
  }

  const focalY = viewportTop + viewportHeight * 0.35;
  let bestIndex = 0;
  let minDistance = Infinity;

  for (let i = 0; i < sectionRects.length; i++) {
    const rect = sectionRects[i];
    if (!rect) continue;

    if (rect.top <= focalY && rect.bottom >= focalY) {
      return i;
    }

    const center = (rect.top + rect.bottom) / 2;
    const distance = Math.abs(center - focalY);
    if (distance < minDistance) {
      minDistance = distance;
      bestIndex = i;
    }
  }

  return bestIndex;
};

export const getSectionTemplateBadge = (section, t) => {
  const tr = typeof t === "function" ? t : (_k, fb) => fb;
  const templateId = section?.templateId;
  switch (templateId) {
    case 1:
      return tr("templateBadge.title", "Tittel");
    case 2:
      return tr("templateBadge.bodyText", "Brødtekst");
    case 3:
      return tr("templateBadge.zigzag", "Zig-zag");
    case 4:
      return tr("templateBadge.video", "Video");
    case 5:
      return tr("templateBadge.sticky", "Sticky");
    case 6:
      return tr("templateBadge.multiSticky", "Multi-sticky");
    case 7:
      return tr("templateBadge.scrollMap", "Scrollekart");
    default:
      break;
  }

  if (section?.type === "stickyMap") return tr("templateBadge.scrollMap", "Scrollekart");
  if (section?.type === "sticky") return tr("templateBadge.sticky", "Sticky");
  if (section?.type === "content") return tr("templateBadge.content", "Innhold");
  return tr("templateBadge.section", "Seksjon");
};

const extractTextFromBlock = (block) => {
  if (!block?.text || typeof block.text !== "string") return "";
  const trimmed = block.text.trim();
  if (trimmed.startsWith("{") && trimmed.includes('"blocks"')) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed?.blocks)) {
        for (const b of parsed.blocks) {
          if (b?.text && typeof b.text === "string" && b.text.trim()) {
            return b.text.trim();
          }
        }
      }
    } catch {
      // Fallback to raw string if JSON parse fails
    }
  }
  return trimmed;
};

export const getSectionDisplayTitle = (section, index = 0, t) => {
  if (section?.title && typeof section.title === "string" && section.title.trim()) {
    return section.title.trim();
  }

  const containers = section?.containers;
  if (Array.isArray(containers)) {
    for (const container of containers) {
      const blocks = container?.blocks;
      if (Array.isArray(blocks)) {
        for (const block of blocks) {
          const raw = extractTextFromBlock(block);
          if (raw) {
            return raw.length > 20 ? `${raw.substring(0, 20)}…` : raw;
          }
        }
      }
    }
  }

  return getSectionTemplateBadge(section, t);
};
